import React, {useState} from 'react'
import {FaTimes} from 'react-icons/fa'
import {KTSVG} from '../../../_metronic/helpers'
function Tab3({values, handleChange, setFieldValue, errors, touched}) {
  const [inputValue, setInputValue] = useState('')
  const [lpInput, setLPInput] = useState('')
  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleLPChanage = (e) => {
    setLPInput(e.target.value)
  }

  function handleAddtags(values, setFieldValue) {
    if (inputValue !== '') {
      setFieldValue('tags', [...values.tags, inputValue])
      setInputValue('')
    }
  }

  function handleAddlps(values, setFieldValue) {
    if (lpInput !== '') {
      setFieldValue('learningPoints', [...values.learningPoints, lpInput])
      setLPInput('')
    }
  }

  return (
    <div className='col-lg-4'>
      <div>
        <label className='col-form-label required fw-bold fs-6'>Tags</label>
        <div className='d-flex align-items-start gap-3'>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Add tags'
            name='tags'
            value={inputValue}
            onChange={(e) => handleInputChange(e)}
          />

          <div
            type='button'
            onClick={() => handleAddtags(values, setFieldValue)}
            className='btn btn-primary '
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          </div>
        </div>
        {touched.tags && errors.tags && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>{errors.tags}</span>
            </div>
          )}

        <div className='d-flex align-items-center flex-wrap gap-5 mt-5'>
          {values.tags.map((val, index) => (
            <div
              key={index}
              className='d-flex gap-8 align-items-center bg-light-primary px-8 py-3 rounded-4 '
              style={{cursor: 'pointer'}}
            >
              <a href='#' className='text-primary fw-semibold fs-6 me-3'>
                {val}{' '}
              </a>
              <div className='rounded-3 p-1' style={{background: 'white'}}>
                <FaTimes
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    fontSize: '18px',
                  }}
                  onClick={() =>
                    setFieldValue(
                      'tags',
                      values.tags.filter((_, i) => i !== index)
                    )
                  }
                />
              </div>
            </div>
          ))}
        </div>

        <label className='col-form-label required fw-bold fs-6 mt-10'>Learning Points</label>
        <div className='d-flex align-items-start gap-3'>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Add learning points'
            name='learningPoints'
            value={lpInput}
            onChange={(e) => handleLPChanage(e)}
          />

          <div
            type='button'
            className='btn btn-primary '
            onClick={() => handleAddlps(values, setFieldValue)}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          </div>
        </div>
        {touched.learningPoints && errors.learningPoints && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>{errors.learningPoints}</span>
            </div>
          )}

        <div className='d-flex align-items-center flex-wrap gap-5 mt-5 '>
          {values.learningPoints &&
            values.learningPoints.map((val, index) => (
              <div
                key={index}
                className='d-flex gap-8 align-items-center bg-light-primary px-8 py-3 rounded-4 '
                style={{cursor: 'pointer'}}
              >
                <a href='#' className='text-primary fw-semibold fs-6 me-3'>
                  {val}{' '}
                </a>
                <div className='rounded-3 p-1' style={{background: 'white'}}>
                  <FaTimes
                    style={{
                      color: 'black',
                      cursor: 'pointer',
                      fontSize: '18px',
                    }}
                    onClick={() =>
                      setFieldValue(
                        'learningPoints',
                        values.learningPoints.filter((_, i) => i !== index)
                      )
                    }
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Tab3
